/* eslint-ignore */
// @ts-nocheck
import React, { useRef, useMemo, useState, useEffect } from 'react';
import ReactInputMask from 'react-input-mask';
import theme from '~/styles/theme';

import IconEyeOn from '~/assets/icons/eye-on.svg';
import IconEyeOff from '~/assets/icons/eye-off.svg';

import { Container, ErrorText, LabelText, CorrectIcon, Eye } from './styles';

const TextField = ({
  LeadingIcon = null,
  TrailingIcon = null,
  label,
  errorMessage = '',
  name,
  errorCondition = false,
  placeholder,
  borderHighlightColor = theme.colors.lightBlue,
  isCorrect = null,
  showChangeTextPassword = false,
  disabled,
  pattern = null,
  value,
  ...rest
}) => {
  const inputRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const [isErrored, setIsErrored] = useState(false);
  const [showText, isShowText] = useState(false);
  const [isLabelActivated, setIsLabelActivated] = useState(false);

  useEffect(() => {
    setIsErrored(!!errorCondition);
  }, [errorCondition]);

  useEffect(() => {
    if (value) setIsLabelActivated(true);
  }, [value]);

  useEffect(() => {
    if (inputRef && inputRef.current) {
      const input = inputRef.current.getInputDOMNode();
      input.addEventListener('blur', () => {
        setIsFocused(false);
      });
      input.addEventListener('focus', () => {
        setIsFocused(true);
      });
    }
  }, [inputRef]);

  useEffect(() => {
    const input = inputRef.current.getInputDOMNode();
    const inputValue = input ? input.value || '' : '';
    if (isFocused || inputValue.length > 0) setIsLabelActivated(true);
    else setIsLabelActivated(false);
  }, [isFocused]);

  useEffect(() => {
    if (showChangeTextPassword) {
      const input = inputRef.current.getInputDOMNode();
      if (input && input.type === 'password' && showText) input.type = 'text';

      if (input && input.type === 'text' && !showText) input.type = 'password';
    }
  }, [showText, showChangeTextPassword]);

  const randomId = useMemo(() => {
    const text = label || '';
    return `${text.replace(/\s/g, '')}-${Math.floor(Math.random() * 100)}`;
  }, [label]);

  return (
    <>
      <Container
        isFocused={isFocused}
        isErrored={isErrored}
        borderHighlightColor={borderHighlightColor}
        disabled={disabled}
      >
        {LeadingIcon && <LeadingIcon id="leading_icon" />}
        <div>
          <LabelText
            labelActivated={isLabelActivated}
            id={`labelId-${randomId}`}
          >
            {label}
          </LabelText>
          <ReactInputMask
            name={name}
            ref={inputRef}
            type="text"
            aria-labelledby={`labelId-${randomId}`}
            placeholder={label ? '' : placeholder}
            aria-controls={`control-${randomId}`}
            aria-describedby={`control-${randomId}`}
            disabled={disabled}
            pattern={pattern || null}
            value={value}
            {...rest}
          />
        </div>
        {inputRef &&
          inputRef.current &&
          inputRef.current.value &&
          isCorrect && <CorrectIcon size={20} />}
        {TrailingIcon && <TrailingIcon />}
        {showChangeTextPassword && (
          <Eye
            src={showText ? IconEyeOn : IconEyeOff}
            onClick={() => isShowText(!showText)}
          />
        )}
      </Container>
      {errorMessage && errorCondition && (
        <ErrorText aria-hidden="true" id={`control-${randomId}`}>
          {' '}
          {errorMessage}
        </ErrorText>
      )}
    </>
  );
};

TextField.defaultProps = {
  LeadingIcon: null,
  TrailingIcon: null,
  label: null,
  errorMessage: null,
  name: null,
  errorCondition: false,
  placeholder: null,
  disabled: null,
  pattern: null,
  value: null,
};

export default TextField;
